export default __webpack_public_path__ + "static/media/gradient-waves.7711710a.svg";